<script>
    import { createEventDispatcher } from "svelte";
    import StatusMessage from "../include/StatusMessage.svelte";
    import { api_post } from "../util/api_request";
    import { user_info } from "../util/stores";

    const dispatch = createEventDispatcher();

    let invite_code = "";
    let mc_name = "";
    let rules_check = false;

    let response_msg;

    let register = async () => {
        response_msg = await api_post("/api/register", {
            mc_name: mc_name,
            invite_code: invite_code
        });

        // Update user info to match new state if registration was successful
        dispatch("update_user_info");
    }
</script>

<div class="content">
    
    <div class="container">
        <h2>Rules</h2>
        <p>The rules are the following:</p>
        <ul>
            <li>No cheating, hacking, or abusing of glitches such as duplication glitches.</li>
            <li>Don't be an asshole.</li>
        </ul>
        <p>That's all.</p>
        <hr>
        <StatusMessage message={response_msg} />

        {#if $user_info.data}
        <div class="container green">You are already whitelisted</div>
        {:else}
        <div class="container">
            <h1 class="center">Getting whitelisted</h1>
            <span class="color-red"></span>
            <form on:submit|preventDefault={register}>
                <div class="divider">
                    <div>
                        <input type="text" placeholder="Invitation code" bind:value={invite_code}>
                    </div>
                    <div>
                        <input
                            class="name-input"
                            style="--mc_head_url:url(https://mc-heads.net/avatar/{mc_name}/24)"
                            type="text"
                            placeholder="Your in game name"
                            bind:value={mc_name} >
                    </div>
                </div>
                <div class="divider">
                    <div class="rules">
                        <label for="rules">I accept the rules: </label>
                        <input bind:checked={rules_check} type="checkbox" required><br>
                    </div>
                    <button type="submit" disabled={!rules_check} class="btn">
                        Register mc account {mc_name}
                    </button>
                </div>
            </form>
        </div>
        {/if}
    </div>
</div>

<style>
    .name-input {
        padding-left: 35px !important;
        background: var(--mc_head_url);
        background-repeat: no-repeat;
        background-position: 4px 4px;
    }

    form .divider {
        margin: 20px 0;
    }

    form .btn {
        margin: 0;
    }
</style>